// noinspection JSUnresolvedFunction,JSIgnoredPromiseFromCall,SpellCheckingInspection

import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { Icon, NavBar } from 'antd-mobile';
import { getBooleanValue } from '../../../../utils';
import { useHistory } from 'react-router-dom';
import Player from 'aliplayer-react';
import { list } from '../../../../services/saas/conference';
import Empty from '@/components/empty';

import { execute } from '../../../../services/saas/onlineCourseTour';
import { getPlayUrl } from '../../../../services/saas/active'; //正式
import { getConnections } from '../../../../services/saas/fileInfo';

const TourVideo = (props) => {
  const id = props.location.pathname.split('/')[4];
  const roomId = props.location.pathname.split('/')[5];

  const history = useHistory();
  const containerRef = useRef(null);
  const [errorInfo, setErrorInfo] = useState({ error: false, msg: '' });
  const [ins, setIns] = useState();
  const [config, setConfig] = useState({
    type: '',
    source: '',
    pic: '',
    width: '100%',
    height: '100%',
    autoplay: false,
    isLive: true,
    rePlay: false,
    playsinline: true,
    preload: true,
    controlBarVisibility: 'hover',
    useH5Prism: true,
  });
  const [liveInfo, setliveInfo] = useState(undefined);

  // eslint-disable-next-line no-unused-vars
  const [backVisable, setVisable] = useState(false);

  function getParamBiz() {
    return JSON.parse(localStorage.getItem('ts-saas-param-biz'));
  }
  function getMonitoringProtocol() {
    const { live_play_agreement_monitoring } = getParamBiz() || {};
    return live_play_agreement_monitoring || 'hls';
  }
  function getFileInfoId() {
    let param = {
      method: 'getMonitoringPlayInfo',
      params: {
        equipmentId: `${id}`,
        playProtocol: 'hls',
      },
    };
    return execute(param);
  }
  async function getIds(fileInfoId) {
    if (errorInfo.error) {
      return;
    }
    let param = {
      fileInfoId: fileInfoId,
    };
    return getConnections(param);
  }
  function getSource(streamId, liveProtocol) {
    return getPlayUrl({
      streamId: streamId,
      playProtocol: liveProtocol,
    });
  }
  function getLiveInfo() {
    let param = {
      size: -1,
      memberId: roomId, //教室id
      conferenceStatus: 1,
    };
    return list(param);
  }

  function setError(res) {
    if (res.success && res.code === 200) {
      return false;
    } else {
      setErrorInfo({ error: true, msg: res.msg });
      return true;
    }
  }

  async function handlerIds(ids) {
    let streamId = null;
    for (let i = 0; i < ids.length; i++) {
      if (ids[i].pushClients > 0) {
        streamId = ids[i].streamId;
      }
    }
    const liveProtocol = getMonitoringProtocol();
    const repPlayUrl = await getSource(streamId, liveProtocol);
    if (setError(repPlayUrl)) {
      return;
    }
    if (repPlayUrl.success) {
      const playUrl = {};
      repPlayUrl.data['hls'].forEach((item) => {
        if (ids[0]['streamFlag'] === item['streamFlag']) {
          playUrl[item['streamFlag']] = item.url;
        }
      });
      config.source = JSON.stringify(playUrl);
      setConfig({ ...config });
    }
  }

  useEffect(() => {
    const getInfo = async () => {
      const res = await getLiveInfo();
      const liveInfo = {};
      if (res.success && res.code === 200) {
        if (res.data['records'].length > 0) {
          liveInfo.className = res.data['records'][0]['memberName'];
          liveInfo.course = res.data['records'][0]['name'];
          liveInfo.teacher = res.data['records'][0]['teachInfo']['lecturerName'];
          setliveInfo(liveInfo);
        }
      } else {
        setErrorInfo({ error: true, msg: res.msg });
      }
    };
    getInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ins) {
      const show = () => {
        setVisable(true);
      };
      const hide = () => {
        setVisable(false);
      };
      const play = () => {
        ins.play();
      };
      ins.on('showBar', show);
      ins.on('hideBar', hide);
      ins.on('canplay', play);
      return () => {
        ins.off('showBar', show);
        ins.off('hideBar', hide);
        ins.off('canplay', play);
      };
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      const res_fileInfoId = await getFileInfoId();
      if (setError(res_fileInfoId)) {
        return;
      }
      // setErrorInfo({ error: res_fileInfoId.success, msg: res_fileInfoId.msg });
      // 连接数小于0，即重试，时限1分钟，1次/秒
      let ids = [];
      let count = 0;
      let timer = setInterval(async function () {
        let res_ids = await getIds(res_fileInfoId.data.fileInfoId);
        if (setError(res_ids)) {
          return;
        }
        ids = res_ids.data.filter(function (ele) {
          return ele['pushClients'] > 0;
        });
        count++;
        if (ids.length > 0) {
          setErrorInfo({ error: false, msg: '' });
          clearInterval(timer);
          timer = null;
          handlerIds(ids);
        } else if (count >= 60) {
          setErrorInfo({ error: true, msg: '暂无推流' });
          clearInterval(timer);
          timer = null;
        }
      }, 1000);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tour-video">
      <NavBar
        mode="light"
        icon={<Icon type="left" />}
        onLeftClick={() => history.goBack()}
        style={
          getBooleanValue('IS_IMMERSE', false)
            ? { marginBottom: '0', paddingTop: '6vw', height: '18vw' }
            : { marginBottom: '0', height: '12vw' }
        }
      >
        {''}
      </NavBar>
      <div className="tour-video-player">
        <div className={errorInfo.error ? 'errorText' : 'hide'}>{errorInfo.msg}</div>
        <div className="tour-video-player" ref={containerRef}>
          {config.source && (
            <Player
              config={config}
              onGetInstance={(instance) => {
                setIns(instance);
              }}
            />
          )}
        </div>
        {liveInfo && (
          <>
            <p className="tour-video-classname">
              <span>{liveInfo.className}</span>
            </p>
            <div className="tour-video-title">
              <img src={[require('../../../../images/ico_class_info.png')]} alt={'课程信息'} />
              <span>课程信息</span>
            </div>
            <p className="tour-video-des">
              <span>课程名称：</span>
              <span>{liveInfo.course}</span>
            </p>
            <p className="tour-video-des">
              <span>授课老师：</span>
              <span>{liveInfo.teacher}</span>
            </p>
          </>
        )}
        {!liveInfo && <Empty />}
      </div>
    </div>
  );
};

export default TourVideo;
